import { render, staticRenderFns } from "./documentModel.vue?vue&type=template&id=4a506618&scoped=true&"
import script from "./documentModel.vue?vue&type=script&lang=js&"
export * from "./documentModel.vue?vue&type=script&lang=js&"
import style0 from "./documentModel.vue?vue&type=style&index=0&id=4a506618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a506618",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a506618')) {
      api.createRecord('4a506618', component.options)
    } else {
      api.reload('4a506618', component.options)
    }
    module.hot.accept("./documentModel.vue?vue&type=template&id=4a506618&scoped=true&", function () {
      api.rerender('4a506618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/manage/documentModel.vue"
export default component.exports